import { queryKey as useRecommendationFeedbacksQueryKey } from "@/composables/recommendationFeedbacks/useRecommendationFeedbacks";

export const onSettled = ({
  queryClient,
}) => (_data, _error, variables) => (
  queryClient.invalidateQueries({ queryKey: useRecommendationFeedbacksQueryKey({ projectId: variables.projectId }) })
)
